'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	teamConfig = require('@mindmup/mindmup-config/src/team-config'),
	teamProviderClass = require('./team-provider-class');

require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');

mmWidgets.fn.subteamListItemWidget = function (subteam, subteamModel) {
	if (!subteam || !subteamModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			provider = teamConfig.getAffiliateProvider(subteam.teamId),
			actionHanders = {
				'delete-sub-team': subteamModel.requestDeleteSubteam,
				'invite': subteamModel.requestConfigureSubteam
				//'remove-member': subteamModel.requestConfigureSubteam
			};
		element.find('[data-mm-role~="item-description"]').text(subteam.description);
		element.find('[data-mm-role~="team-provider"]').addClass(teamProviderClass(provider));
		element.find('[data-mm-role~="item-role"]').text(subteam.role);
		element.find('[data-mm-subteam-actions]').addClass('disabled');
		if (subteam.allowedActions) {
			subteam.allowedActions.forEach(action => {
				const actionElement = element.find(`[data-mm-subteam-actions~="${action}"]`);
				actionElement.removeClass('disabled');
				actionElement.click(() => actionHanders[action] && actionHanders[action](subteam));
			});
		}
	});
};


mmWidgets.fn.subteamListWidget = function (subteamModel) {
	if (!subteamModel) {
		throw new Error('invalid-args');
	}

	return mmWidgets.each(this, function () {
		const element = mmWidgets(this).sectionHandlerWidget(),
			itemTemplate = element.find('[data-mm-role~="list-item-template"]').detach(),
			listContainer = element.find('[data-mm-role~="list-container"]');
		subteamModel.addEventListener('context', context => {
			if (context.progressMessage) {
				element.showProgressMessage(context.progressMessage);
			}  else {
				const teamList = context?.teamList?.filter(i => !i.provider);
				if (teamList && teamList.length) {
					listContainer.empty();
					teamList.forEach(subteam => {
						const itemWidget = itemTemplate.clone().subteamListItemWidget(subteam, subteamModel);
						listContainer.append(itemWidget);
					});
					element.showSection('sub-team-list');
				} else {
					element.showSection('list-empty');
				}
			}
		});
	});
};
